import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_ADMIN_CASHFLOW = `${URL_APP_ADMIN}/cashflow`
const URL_ADMIN_CASHFLOW_PRICE_AUDIT_LANDING = `${URL_ADMIN_CASHFLOW}/price-audit`
const URL_ADMIN_CASHFLOW_PRICE_AUDIT_DETAILS = `${URL_ADMIN_CASHFLOW}/price-audit/:auditReviewUuid`
const URL_ADMIN_CASHFLOW_PRICE_AUDIT_FEEDBACK = `${URL_ADMIN_CASHFLOW}/price-audit/feedback/:userId?`
const URL_ADMIN_CASHFLOW_CHECKOUT_DISCREPANCY_AUDIT_LANDING = `${URL_ADMIN_CASHFLOW}/checkout-discrepancy-audit`
const URL_ADMIN_CASHFLOW_CHECKOUT_DISCREPANCY_AUDIT_DETAILS = `${URL_ADMIN_CASHFLOW}/checkout-discrepancy-audit/:auditReviewUuid`
const URL_ADMIN_CASHFLOW_TRANSACTION_INTEGRITY_AUDIT = `${URL_ADMIN_CASHFLOW}/transaction-integrity-audit`
const URL_ADMIN_CASHFLOW_GOLDEN_RECEIPT = `${URL_ADMIN_CASHFLOW}/golden-receipt`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-cashflow'>
  | DashRouteType<'app-admin-cashflow-price-audit-landing'>
  | DashRouteType<'app-admin-cashflow-price-audit-details'>
  | DashRouteType<'app-admin-cashflow-price-audit-feedback'>
  | DashRouteType<'app-admin-cashflow-checkout-discrepancy-audit-landing'>
  | DashRouteType<'app-admin-cashflow-checkout-discrepancy-audit-details'>
  | DashRouteType<'app-admin-cashflow-transaction-integrity-audit'>
  | DashRouteType<'app-admin-cashflow-golden-receipt'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-cashflow': URL_ADMIN_CASHFLOW,
  'app-admin-cashflow-price-audit-landing': URL_ADMIN_CASHFLOW_PRICE_AUDIT_LANDING,
  'app-admin-cashflow-price-audit-details': URL_ADMIN_CASHFLOW_PRICE_AUDIT_DETAILS,
  'app-admin-cashflow-price-audit-feedback': URL_ADMIN_CASHFLOW_PRICE_AUDIT_FEEDBACK,
  'app-admin-cashflow-checkout-discrepancy-audit-landing':
    URL_ADMIN_CASHFLOW_CHECKOUT_DISCREPANCY_AUDIT_LANDING,
  'app-admin-cashflow-checkout-discrepancy-audit-details':
    URL_ADMIN_CASHFLOW_CHECKOUT_DISCREPANCY_AUDIT_DETAILS,
  'app-admin-cashflow-transaction-integrity-audit': URL_ADMIN_CASHFLOW_TRANSACTION_INTEGRITY_AUDIT,
  'app-admin-cashflow-golden-receipt': URL_ADMIN_CASHFLOW_GOLDEN_RECEIPT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
